import React, { Component } from 'react';

class ArticuloFittingBox extends Component {
  fitmixInstance = undefined;

  componentDidMount() {
    const params = {
      apiKey: 'TBVAcXitApiZPVH791yxdHbAc8AKzBwtCnjtv6Xn',
      sku: '1703-433490',
      liveAutostart: true,
    };
    this.fitmixInstance = window.FitMix.createWidget('my-fitmix-container', params, () => {

    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const skus = ['1703-433490', '1703-433486', '1702-432979', '1702-432988'];
    const randomFrame = skus[Math.floor(Math.random() * 10) % 4];
    this.fitmixInstance.setFrame(randomFrame);
  }

  render() {
    const { height } = this.props;
    return (
      <div style={{ height: (height) || '60vh' }}>
        <div id="my-fitmix-container" style={{ height: '100%', width: '100%' }} />
      </div>
    );
  }
}

ArticuloFittingBox.propTypes = {};

export default ArticuloFittingBox;
